import { Routes, Route, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Navigate } from 'react-router';
import { ApplicantProfileContactViewContainer } from '../components/applicant-profile-contact-view.container';
import { ApplicantProfileContactEditContainer } from '../components/applicant-profile-contact-edit.container';

export const ApplicantProfileContact: React.FC = () => {
  const params = useParams();

  return (
    <div>
      <Helmet>
        <title>Applicant - Contact</title>
      </Helmet>
      <Routes>
        <Route index element={<Navigate to="view" replace />} />
        <Route path="view/*" element={<ApplicantProfileContactViewContainer applicantId={params.applicantId || ''} />} />
        <Route path="edit/*" element={<ApplicantProfileContactEditContainer applicantId={params.applicantId || ''} />} />
      </Routes>
    </div>
  );
};
